// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { COMPLETED_WORK_ACCESS_DEFAULT, CompletedWorkAccessModel } from './completed-work-access.model';

@State({ name: 'CompletedWorkAccess' })
@Injectable()
export class CompletedWorkAccessState {

  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateContractsAccess(roles: PermissionEnum[], user: UserModel): CompletedWorkAccessModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: CompletedWorkAccessModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): CompletedWorkAccessModel {
    switch (role) {
      case PermissionEnum.CAN_READ_COMPLETED_WORK_AS_ADMIN:
        return {
          ...COMPLETED_WORK_ACCESS_DEFAULT,
          canReadCompletedWorkAsAdmin: true
        };

      case PermissionEnum.CAN_READ_COMPLETED_WORK:
        return {
          ...COMPLETED_WORK_ACCESS_DEFAULT,
          canReadCompletedWork: true
        };

      case PermissionEnum.SUPER_USER:
        return {
          canReadCompletedWork: true,
          canReadCompletedWorkAsAdmin: true
        };
      default: {
        return {
          ...COMPLETED_WORK_ACCESS_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: CompletedWorkAccessModel[]): CompletedWorkAccessModel {
    const moduleConfig: CompletedWorkAccessModel = COMPLETED_WORK_ACCESS_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadCompletedWork = moduleConfig.canReadCompletedWork ? true : config.canReadCompletedWork;
      moduleConfig.canReadCompletedWorkAsAdmin = moduleConfig.canReadCompletedWorkAsAdmin ? true : config.canReadCompletedWorkAsAdmin;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToCompletedWork(profileState: ProfileStateModel, accessState: AccessStateModel): CompletedWorkAccessModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return CompletedWorkAccessState.generateContractsAccess(roleList, userData);
  }

}


